/**
 * Fly-to-Cart Butterfly Animation — buttonsbebe.com
 * ----------------------------------------------------
 * When an item is successfully added to the cart, a butterfly icon flies
 * from the clicked Add to Cart button to the cart icon in the header, then
 * fades out with a little bounce on arrival.
 *
 * Hooks into the theme's own pub/sub system (MinimogEvents), specifically
 * the same "cartUpdate" event the theme itself emits after every successful
 * cart addition (confirmed directly in assets/theme-global.js, cart.js,
 * gift-wrapping.js, and product-bundles.js) — so this fires reliably
 * regardless of which specific add-to-cart flow triggered it (main product
 * form, quick-add on a collection card, bundles, etc).
 *
 * Since that event doesn't include which button was clicked, a click
 * listener on any Add to Cart button captures the click position first,
 * and the animation uses whichever position was captured most recently.
 */
(function () {
  'use strict';

  var lastClickPosition = null;
  var lastStaticButterfly = null;

  function captureClickPosition(e) {
    var button = e.target.closest('.m-add-to-cart, [name="add"]');
    if (!button) return;

    var staticButterfly = button.querySelector('[data-static-butterfly]');
    if (staticButterfly) {
      var iconRect = staticButterfly.getBoundingClientRect();
      lastClickPosition = {
        x: iconRect.left + iconRect.width / 2,
        y: iconRect.top + iconRect.height / 2,
      };
      staticButterfly.classList.add('m-add-to-cart__butterfly--hidden');
      lastStaticButterfly = staticButterfly;
    } else {
      var rect = button.getBoundingClientRect();
      lastClickPosition = {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
      };
      lastStaticButterfly = null;
    }
  }

  function getVisibleCartIcon() {
    var icons = document.querySelectorAll('.m-cart-icon-bubble');
    for (var i = 0; i < icons.length; i++) {
      if (icons[i].offsetParent !== null) {
        var rect = icons[i].getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return icons[i];
      }
    }
    return null;
  }

  function flyButterflyToCart() {
    if (!lastClickPosition) return;

    var cartIcon = getVisibleCartIcon();
    if (!cartIcon) return;

    var cartRect = cartIcon.getBoundingClientRect();
    var destination = {
      x: cartRect.left + cartRect.width / 2,
      y: cartRect.top + cartRect.height / 2,
    };

    var butterfly = document.createElement('img');
    butterfly.src = window.__butterflyIconUrl || '';
    butterfly.className = 'm-fly-to-cart-butterfly';
    butterfly.style.left = lastClickPosition.x + 'px';
    butterfly.style.top = lastClickPosition.y + 'px';
    document.body.appendChild(butterfly);

    // Force a reflow so the initial position is committed before we
    // transition to the destination — otherwise the browser may skip
    // straight to the end state with no visible animation.
    void butterfly.offsetWidth;

    var deltaX = destination.x - lastClickPosition.x;
    var deltaY = destination.y - lastClickPosition.y;

    butterfly.style.transform =
      'translate(' + deltaX + 'px, ' + deltaY + 'px) scale(0.3) rotate(20deg)';
    butterfly.style.opacity = '0';

    butterfly.addEventListener('transitionend', function () {
      butterfly.remove();
      cartIcon.classList.add('m-cart-icon-bubble--bounce');
      setTimeout(function () {
        cartIcon.classList.remove('m-cart-icon-bubble--bounce');
      }, 400);
      if (lastStaticButterfly) {
        lastStaticButterfly.classList.remove('m-add-to-cart__butterfly--hidden');
        lastStaticButterfly = null;
      }
    });

    // Safety net in case transitionend doesn't fire for any reason
    setTimeout(function () {
      if (butterfly.parentNode) butterfly.remove();
      if (lastStaticButterfly) {
        lastStaticButterfly.classList.remove('m-add-to-cart__butterfly--hidden');
        lastStaticButterfly = null;
      }
    }, 2200);

    lastClickPosition = null;
  }

  document.addEventListener('click', captureClickPosition, true);

  function positionStaticButterflies() {
    var buttons = document.querySelectorAll('.m-add-to-cart');
    buttons.forEach(function (button) {
      var text = button.querySelector('[data-atc-text-measure]');
      var icon = button.querySelector('[data-static-butterfly]');
      if (!text || !icon) return;

      var buttonWidth = button.offsetWidth;
      var textWidth = text.offsetWidth;
      var iconWidth = icon.offsetWidth || 22;
      var gap = 10;

      // Text is centered by the button's own flex layout — this calculates
      // where its right edge actually lands, then places the icon just
      // after it, so the text itself stays exactly centered regardless of
      // the icon's presence.
      var textRightEdge = buttonWidth / 2 + textWidth / 2;
      var iconLeft = textRightEdge + gap;

      icon.style.left = iconLeft + 'px';
      icon.classList.add('m-add-to-cart__butterfly--positioned');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionStaticButterflies);
  } else {
    positionStaticButterflies();
  }
  window.addEventListener('load', positionStaticButterflies);
  window.addEventListener('resize', positionStaticButterflies);
  // Also reposition shortly after load in case webfonts shift text width
  setTimeout(positionStaticButterflies, 500);

  function init() {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, flyButterflyToCart);
    } else {
      // Theme's event system may not be ready yet on very first load; retry briefly
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, flyButterflyToCart);
          clearInterval(interval);
        } else if (attempts > 30) {
          clearInterval(interval);
        }
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();